import { gql } from "@apollo/client";

export const GET_PLAN_BY_ID_QUERY = gql`
  query DigitalTwinPlans($_id: String) {
    digitalTwinPlanById(_id: $_id) {
      _id
      digital_twin_id
      surgical_parameters
      creation
      current_measurements
      target_measurements
    }
  }
`;

export const GET_PLANS_BY_IDS_QUERY = gql`
  query DigitalTwinPlansByIds($ids: [String]) {
    digitalTwinPlansByIds(ids: $ids) {
      _id
      creation
      surgical_parameters
      digital_twin_id
      current_measurements
      target_measurements
    }
  }
`;
